import * as CryptoJS from 'crypto-js';

export function encryptData(data: any) {
  const secret: string = localStorage.getItem('tempKey')!;
  const key = CryptoJS.enc.Utf8.parse(secret);
  const iv = CryptoJS.enc.Utf8.parse(secret);

  const encryptedData = CryptoJS.AES.encrypt(JSON.stringify(data), key, {
    keySize: 256,
    iv,
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7,
  });

  return encryptedData.toString();
}

export function decryptData(data: any) {
  const secret: string = localStorage.getItem('tempKey')!;
  const key = CryptoJS.enc.Utf8.parse(secret);
  const iv = CryptoJS.enc.Utf8.parse(secret);

  const decryptedData = JSON.parse(
    CryptoJS.AES.decrypt(data, key, {
      keySize: 256,
      iv,
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7,
    }).toString(CryptoJS.enc.Utf8)
  );

  return decryptedData;
}
